import styles from './Empty.module.scss'

import bookshelfImgSrc from './img/empty-shelf.jpg'

export default class Empty extends React.PureComponent {
  render() {
    const {
      className,
      ...passedProps
    } = this.props
    return (
      <div {...passedProps} className={cx('article', className, styles.root)}>
        <img src={bookshelfImgSrc} className={styles.bookshelf} alt="empty bookshelf" />
        <div className={cx(styles.content)}>
          <p>You have no courses</p>
        </div>
      </div>
    )
  }
}
